import {useEffect, useState, Fragment} from "react";
import SummaryGraphicPoint from "./SummaryGraphicPoint";
import SummaryGraphicFlexedPoint from "./SummaryGraphicFlexedPoint";


const ROIGraphical = (props) => {

    const [data, setData] = useState([])
    const [organisations, setOrganisations] = useState([])
    const [pillars, setPillars] = useState([])

    const teams = Array.isArray(props.teams) ? props.teams : [];

    useEffect(() => {
        setData(props.data)
    }, [props.data]);

    useEffect(() => {
        setPillars(props.pillars)
    }, [props.pillars])

    useEffect(() => {
        if (!props.teams || !props.teams.length) return;
        let c = []
        for (const team of props.teams) {
            if (!(c.map(x => x.name).includes(team.organisation_name))) {
                c.push({
                    "name": team.organisation_name,
                    "colour": team.organisation_colour
                })
            }
        }
        setOrganisations(c)
    }, [props.teams]);

    const normal_round = (value) => {
        if (!value) return;
        if (value - Math.floor(value) < 0.5) return Math.floor(value);
        return Math.ceil(value)
    }

    const getPillarColour = (pillar_id) => {
        switch (pillar_id) {
            case 1: return "pillar-blue"
            case 2: return "pillar-red"
            case 3: return "pillar-green"
            case 4: return "pillar-purple"
            case 5: return "pillar-pink"
            case 6: return "pillar-orange"
        }
    }

    const IncludesIndex = (idx, array) => {
        let isFound = array.includes(idx);
        return !!isFound;
    }

    const scorePoints = (level, pillar_idx) => {
        let points = []
        let _totals = []
        let max = 0
        let min = 0

        switch (level) {
            case "high":
                max = 100
                min = 33
                break;
            case "mid":
                max = 33
                min = -33
                break;
            case "low":
                max = -33
                min = -100
        }

        for (const organisation of data.organisations) {
            let name = organisation.name;
            let colour = "#" + organisation.colour;
            let demo = organisation.demo;
            let org_scores = [];
            let i = 1;

            for (const team of organisation.team_data){
                let top = 100 - ((team.scores[pillar_idx] - min) * 100 / (max - min))

                if (team.scores[pillar_idx] > min && team.scores[pillar_idx] <= max){
                    points.push({
                        "colour": colour,
                        "type": "individual",
                        "top": top,
                        "name": team.name,
                        "hidden_name": `Team ${i}`,
                        "score": normal_round(team.scores[pillar_idx])
                    })
                }
                else if (max === 100 && team.scores[pillar_idx] > max){
                    points.push({
                        "colour": colour,
                        "type": "individual",
                        "top": 0,
                        "name": team.name,
                        "hidden_name": `Team ${i}`,
                        "score": normal_round(team.scores[pillar_idx])
                    })
                }
                else if (min === -100 && team.scores[pillar_idx] < min){
                    points.push({
                        "colour": colour,
                        "type": "individual",
                        "top": 76,
                        "name": team.name,
                        "hidden_name": `Team ${i}`,
                        "score": normal_round(team.scores[pillar_idx])
                    })
                }

                org_scores.push(team.scores[pillar_idx]);
                i++
            }

            if (org_scores.length > 0){
                let _total = 0;
                org_scores.forEach(score => _total += score);
                let _average = _total / org_scores.length;
                let top = 100 - ((_average - min) * 100 / (max - min))

                if (_average > min && _average <= max){
                    points.push({
                        "colour": colour,
                        "type": "average",
                        "top": top,
                        "name": name + " Average",
                        "score": normal_round(_average)
                    })
                }
                else if (max === 100 && _average > max){
                    points.push({
                        "colour": colour,
                        "type": "average",
                        "top": 0,
                        "name": name + " Average",
                        "score": normal_round(_average)
                    })
                }
                else if (min === -100 && _average < min){
                    points.push({
                        "colour": colour,
                        "type": "average",
                        "top": 76,
                        "name": name + " Average",
                        "score": normal_round(_average)
                    })
                }
            }
        }

        return points;
    }

    return (
        <div className="roi-graphical-container">
            <div className="roi-graphical-header-container">
                <div className="roi-graphical-title-container">
                    <div className="summary-tabular-title">Graphical View: Team Performance Change (%) by Pillar</div>
                    <div className="roi-graphical-key-container">
                        <div className="key-point-outer">
                            <div className="key-point-inner"></div>
                        </div>
                        <div className="key-text medium">Teams</div>
                        <div className="key-mean"/>
                        <div className="key-text medium">Organisations Average Score</div>
                    </div>
                </div>
            </div>

            {(teams?.length ?? 0) > 0 ? (
                <>
                    <div className="roi-report-title-card-organisations-container no-border">
                        {organisations.map((organisation, idx) => (
                            <div
                                className="roi-report-title-card-organisation bold"
                                key={idx}
                            >
                                <div
                                    className="roi-report-title-card-organisation-colour"
                                    style={{backgroundColor: organisation.colour}}
                                />
                                <div className="roi-report-title-card-organisation-name">
                                    {organisation.name}
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="roi-graphical-table-container">
                        <div className="summary-graphical-table-left-spacer">
                            <div className="summary-graphical-spacer-segment top-label">100%</div>
                            <div className="summary-graphical-spacer-segment">33%</div>
                            <div className="summary-graphical-spacer-segment">-33%</div>
                            <div className="summary-graphical-spacer-segment no-border">-100%</div>
                            <div className="summary-graphical-spacer-segment no-border corner"/>
                        </div>

                        {pillars?.map((pillar, idx) => (
                            <Fragment key={idx}>
                                <div
                                    className="summary-graphical-table-column-container"
                                    style={{zIndex: 7 - idx}}
                                >
                                    {/* TOP */}
                                    <div
                                        className={`summary-graphical-table-column-top ${
                                            idx === 0
                                                ? "left-corner"
                                                : idx === 4
                                                    ? "right-corner"
                                                    : ""
                                        }`}
                                    >
                                        {scorePoints("high", idx).map((points, point_idx) =>
                                            points.type === "individual" ? (
                                                <SummaryGraphicPoint
                                                    key={point_idx}
                                                    points={points}
                                                    usePercent
                                                    attributableData
                                                    idx={point_idx}
                                                />
                                            ) : points.type === "average" ? (
                                                <div
                                                    className="summary-graphical-average"
                                                    style={{
                                                        top: `calc(${points.top}% - 3px)`,
                                                        backgroundColor: points.colour,
                                                    }}
                                                    key={`avg-top-${point_idx}`}
                                                >
                                                    <div className="summary-graphical-point-hover-container average">
                                                        <div className="summary-graphical-point-hover-triangle">
                                                            <div
                                                                className="summary-graphical-point-hover-triangle-inner"/>
                                                        </div>
                                                        <div className="summary-graphical-point-hover-main">
                                                            <div className="summary-graphical-average-hover-details">
                                                                <div className="hover-details-key">% Change</div>
                                                                <div className="hover-details-score">
                                                                    {points.score + "%"}
                                                                </div>
                                                            </div>
                                                            <div className="summary-graphical-point-hover-circle" style={{backgroundColor: points.colour}}/>
                                                            <div className="summary-graphical-point-hover-text">
                                                                {points.name}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ) : points.type === "multi-points" ? (
                                                <div
                                                    className="summary-graphical-multi-points-container"
                                                    style={{top: `${points.top}%`}}
                                                    key={`multi-top-${point_idx}`}
                                                >
                                                    {points.data?.map((point, i) => (
                                                        <SummaryGraphicFlexedPoint
                                                            key={i}
                                                            point={point}
                                                            data={points.data}
                                                            attributableData
                                                            idx={i}
                                                        />
                                                    ))}
                                                </div>
                                            ) : null
                                        )}
                                    </div>

                                    {/* MIDDLE */}
                                    <div className="summary-graphical-table-column-middle">
                                        {scorePoints("mid", idx).map((points, point_idx) =>
                                            points.type === "individual" ? (
                                                <SummaryGraphicPoint
                                                    key={point_idx}
                                                    points={points}
                                                    usePercent
                                                    attributableData
                                                    idx={point_idx}
                                                />
                                            ) : points.type === "average" ? (
                                                <div
                                                    className="summary-graphical-average"
                                                    style={{
                                                        top: `calc(${points.top}% - 3px)`,
                                                        backgroundColor: points.colour,
                                                    }}
                                                    key={`avg-mid-${point_idx}`}
                                                >
                                                    <div className="summary-graphical-point-hover-container average">
                                                        <div className="summary-graphical-point-hover-triangle">
                                                            <div
                                                                className="summary-graphical-point-hover-triangle-inner"/>
                                                        </div>
                                                        <div className="summary-graphical-point-hover-main">
                                                            <div className="summary-graphical-average-hover-details">
                                                                <div className="hover-details-key">% Change</div>
                                                                <div className="hover-details-score">
                                                                    {points.score + "%"}
                                                                </div>
                                                            </div>
                                                            <div
                                                                className="summary-graphical-point-hover-circle"
                                                                style={{backgroundColor: points.colour}}
                                                            />
                                                            <div className="summary-graphical-point-hover-text">
                                                                {points.name}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ) : points.type === "multi-points" ? (
                                                <div
                                                    className="summary-graphical-multi-points-container"
                                                    style={{top: `${points.top}%`}}
                                                    key={`multi-mid-${point_idx}`}
                                                >
                                                    {points.data?.map((point, i) => (
                                                        <SummaryGraphicFlexedPoint
                                                            key={i}
                                                            point={point}
                                                            data={points.data}
                                                            attributableData
                                                            idx={i}
                                                        />
                                                    ))}
                                                </div>
                                            ) : null
                                        )}
                                    </div>

                                    {/* BOTTOM */}
                                    <div className="summary-graphical-table-column-bottom">
                                        {scorePoints("low", idx).map((points, point_idx) =>
                                            points.type === "individual" ? (
                                                <SummaryGraphicPoint
                                                    key={point_idx}
                                                    points={points}
                                                    usePercent
                                                    attributableData
                                                    idx={point_idx}
                                                />
                                            ) : points.type === "average" ? (
                                                <div
                                                    className="summary-graphical-average"
                                                    style={{
                                                        top: `calc(${points.top}% - 3px)`,
                                                        backgroundColor: points.colour,
                                                    }}
                                                    key={`avg-low-${point_idx}`}
                                                >
                                                    <div className="summary-graphical-point-hover-container average">
                                                        <div className="summary-graphical-point-hover-triangle">
                                                            <div
                                                                className="summary-graphical-point-hover-triangle-inner"/>
                                                        </div>
                                                        <div className="summary-graphical-point-hover-main">
                                                            <div className="summary-graphical-average-hover-details">
                                                                <div className="hover-details-key">% Change</div>
                                                                <div className="hover-details-score">
                                                                    {points.score + "%"}
                                                                </div>
                                                            </div>
                                                            <div
                                                                className="summary-graphical-point-hover-circle"
                                                                style={{backgroundColor: points.colour}}
                                                            />
                                                            <div className="summary-graphical-point-hover-text">
                                                                {points.name}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ) : points.type === "multi-points" ? (
                                                <div
                                                    className="summary-graphical-multi-points-container"
                                                    style={{top: `${points.top}%`}}
                                                    key={`multi-low-${point_idx}`}
                                                >
                                                    {points.data?.map((point, i) => (
                                                        <SummaryGraphicFlexedPoint
                                                            key={i}
                                                            point={point}
                                                            data={points.data}
                                                            attributableData
                                                            idx={i}
                                                        />
                                                    ))}
                                                </div>
                                            ) : null
                                        )}
                                    </div>

                                    {/* PILLAR LABEL */}
                                    <div className="summary-graphical-table-column-text-container">
                                        <div
                                            className={`summary-graphical-table-column-pillar-colour ${getPillarColour(
                                                pillar.pillar_id
                                            )}`}
                                        />
                                        <div className="summary-graphical-table-column-pillar-text">
                                            {pillar.name}
                                        </div>
                                    </div>
                                </div>

                                <div
                                    className={`summary-graphical-table-centre-spacer ${
                                        idx === 4 ? "thin" : ""
                                    }`}
                                    key={`spacer-${idx}`}
                                >
                                    <div className="summary-graphical-spacer-segment"/>
                                    <div className="summary-graphical-spacer-segment"/>
                                    <div className="summary-graphical-spacer-segment no-border"/>
                                    <div className="summary-graphical-spacer-segment no-border"/>
                                </div>
                            </Fragment>
                        ))}
                    </div>
                </>
            ) : (
                <div className="roi-report-title-card-no-teams">No teams selected</div>
            )}
        </div>
    );
}
export default ROIGraphical